import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { ctaImage } from "../data/realisations";
import { site } from "../data/site";

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden" data-testid="cta-banner">
      <img src={ctaImage} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-forest-dark/85" />
      <div className="grain absolute inset-0" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-8 py-20 lg:py-28 text-center">
        <Reveal>
          <span className="eyebrow text-moss">Devis gratuit et sans engagement</span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-sand leading-[1.08]">
            Un projet pour votre jardin ? <em className="italic">Parlons-en.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-5 text-base sm:text-lg text-sand/75 font-light max-w-xl mx-auto">
            Décrivez-nous votre besoin et recevez une réponse adaptée à votre projet.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/demander-un-devis" data-testid="cta-banner-devis-button" className="btn-light w-full sm:w-auto">
              Demander un devis <ArrowRight size={15} />
            </Link>
            <a href={site.phoneHref} data-testid="cta-banner-phone-link" className="btn-outline w-full sm:w-auto">
              Nous contacter
            </a>
          </div>
          <p className="mt-6 text-sm text-sand/60">
            Ou <Link to="/rendez-vous" data-testid="cta-banner-rdv-link" className="text-sand font-semibold underline underline-offset-4 decoration-moss/60">prenez rendez-vous en ligne</Link>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
